import {
  ADD_OPPORTUNITY_CONTACT_LOAD_ROLES,
} from './actions';

// Initial State
const initialState = {
  roles: {}, // indexed by organization_id
};

const AddOpportunityContactReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_OPPORTUNITY_CONTACT_LOAD_ROLES: {
      const { roles, status, errors, organizationId } = action;
      const currentRoles = state.roles;
      const newRoles = { ...currentRoles, [organizationId]: { roles, status, errors } };
      return {
        ...state,
        roles: newRoles,
      };
    }
    default:
      return state;
  }
};

/* Selectors */
export const getRolesLoading = (state, organizationId) => {
  const info = state.addOpportunityContact.roles[organizationId] || {};
  return info.status === 'loading';
};
export const getRolesLoaded = (state, organizationId) => {
  const info = state.addOpportunityContact.roles[organizationId] || {};
  return info.status === 'loaded';
};
export const getRolesHasErrors = (state, organizationId) => {
  const info = state.addOpportunityContact.roles[organizationId] || {};
  return info.status === 'error';
};
export const getRoles = (state, organizationId) => {
  const info = state.addOpportunityContact.roles[organizationId] || {};
  return info.roles || [];
};

// Export Reducer
export default AddOpportunityContactReducer;
